<template>
    <component :is="display" />
</template>

<script>
export default {
    computed: {
        scope() {
            return this.$store.state.scope;
        },
        display() {
            if(this.scope.includes("console")) return () => import("./product/ProductListPage.vue");
            return null;
        },
    },
};
</script>
